import React from 'react'
import ProjectDetailsHeader from 'src/components/molecules/ProjectDetailsHeader'
import { Project } from 'src/types/projects'

interface Props {
  project: Project
  onBack: () => void
  stage?: { id: string; name: string } | null
}

// embedUrl is a short-lived SAS minted per request by the API, so it is never persisted.
// sandbox stays at allow-scripts only: allow-same-origin would let the frame reach the parent app.
const ProjectEmbedView: React.FC<Props> = ({ project, onBack, stage }) => {
  return (
    <>
      <ProjectDetailsHeader project={project} onBack={onBack} stage={stage} />
      <div className="relative flex-1">
        <iframe
          src={project.embedUrl}
          className="h-full w-full border-0"
          title={project.name}
          sandbox="allow-scripts"
          referrerPolicy="no-referrer"
        />
      </div>
    </>
  )
}

export default ProjectEmbedView
